module.exports = __webpack_public_path__ + "media/images/flags/gm-b45b9104e7bbc3c762a7846f2beeef7d.svg";